import styled from '@emotion/styled';
import { IPublicCompany } from 'domain/entities/Company/Company';
import ArrowIcon from 'ui/images/arrow.svg';
import { useNavigate } from 'react-router-dom';
import { PublicCompanyCard } from 'ui/components/agent/features/Card/PublicCompanyCard';

interface NewCompanyListProps {
    companies: IPublicCompany[];
}

const Wrapper = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    margin-top: 40px;
    margin-bottom: 40px;
`;

const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Title = styled.h1`
    font-weight: 700;
    font-size: 18px;
`;

const MoreButton = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;

    img {
        width: 19px;
        height: 19px;
    }
`;

const CompaniesWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
`;

export const NewCompanyList: React.FC<NewCompanyListProps> = ({ companies }) => {
    const navigate = useNavigate();

    return (
        <Wrapper>
            <TitleContainer>
                <Title>新着売り手企業</Title>
                <MoreButton onClick={() => navigate('/agent/company/list/')}>
                    もっと見る
                    <img src={ArrowIcon} alt="もっと見る" />
                </MoreButton>
            </TitleContainer>
            <CompaniesWrapper>
                {companies.map((company) => (
                    <PublicCompanyCard
                        key={company.id}
                        company={company}
                        onClick={() => navigate(`/agent/companies/${company.id}/`)}
                    />
                ))}
            </CompaniesWrapper>
        </Wrapper>
    );
};
